module.exports = __webpack_public_path__ + "static/media/Maf_Curso_05AtencionAVictimas.4562b412.jpg";